import { Injectable } from '@angular/core';
import { AssetService } from '@rd/core/services/asset-service/asset.service';

const GRADIENT_ICONS: string[] = [
  'icon-account-linking-failed.svg',
  'icon-arrow-right-gradient.svg',
  'icon-arrow-right.svg',
  'icon-autosweep-success.svg',
  'icon-cash-autosweep.svg',
  'icon-close.svg',
  'icon-error.svg',
  'icon-failed.svg',
  'icon-info.svg',
  'icon-linked.svg',
  'icon-no-linked-account.svg',
  'icon-noresultsgc.svg',
  'icon-offer-category-virgin.svg',
  'icon-offer-listing-empty.svg',
  'icon-plane.svg',
  'icon-rc-enrollments-empty.svg',
  'icon-share-points-empty.svg',
  'icon-tc-listing-empty-state-filter.svg',
  'icon-unexpected-error.svg',
];

@Injectable({ providedIn: 'root' })
export class VmaAssetService extends AssetService {
  getIconPath(name: string): string {
    const assetName = `icon-${name}.svg`;
    const rebrandingAssetName = `icon-${name}-rebranding.svg`;
    const hashedAssetKey = GRADIENT_ICONS.includes(assetName)
      ? rebrandingAssetName
      : assetName;

    return `/${this.assetMap.icons[hashedAssetKey].path.hashedPath}`;
  }
}
